import {
  GET_TRAJET_REPORT_FUNNEL_CHART_DATA,
  GET_TRAJET_REPORT_LEAD_DATA,
  GET_TRAJET_REPORT_LEAD_DETAIL_DATA,
  GET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
  GET_TRAJET_REPORT_LOV_DATA,
  GET_TRAJET_REPORT_TEAM_DATA,
  SET_TRAJET_REPORT_BREADCRUMB_DATA,
  SET_TRAJET_REPORT_FUNNEL_CHART_DATA,
  SET_TRAJET_REPORT_LEAD_DATA,
  SET_TRAJET_REPORT_LEAD_DETAIL_DATA,
  SET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
  SET_TRAJET_REPORT_LOV_DATA,
  SET_TRAJET_REPORT_TEAM_DATA,
  SET_TRAJET_REPORT_TEAM_LEAD_ASSIGNED_DATA,
} from '@stores/trajetReport/constants.js';

export const setTrajetReportBreadcrumbDataAction = (payload) => ({
  type: SET_TRAJET_REPORT_BREADCRUMB_DATA,
  payload,
});

export const getTrajetReportTeamDataAction = (payload, callback) => ({
  type: GET_TRAJET_REPORT_TEAM_DATA,
  payload,
  callback,
});

export const setTrajetReportTeamDataAction = (payload) => ({
  type: SET_TRAJET_REPORT_TEAM_DATA,
  payload,
});

export const getTrajetReportLeadAction = (payload, callback) => ({
  type: GET_TRAJET_REPORT_LEAD_DATA,
  payload,
  callback,
});

export const setTrajetReportLeadAction = (payload) => ({
  type: SET_TRAJET_REPORT_LEAD_DATA,
  payload,
});

export const getTrajetReportFunnelChartAction = (payload, callback) => ({
  type: GET_TRAJET_REPORT_FUNNEL_CHART_DATA,
  payload,
  callback,
});

export const setTrajetReportFunnelChartAction = (payload) => ({
  type: SET_TRAJET_REPORT_FUNNEL_CHART_DATA,
  payload,
});

export const getTrajetReportLeadDetailAction = (payload) => ({
  type: GET_TRAJET_REPORT_LEAD_DETAIL_DATA,
  payload,
});

export const setTrajetReportLeadDetailAction = (payload, callback) => ({
  type: SET_TRAJET_REPORT_LEAD_DETAIL_DATA,
  payload,
  callback,
});

export const getTrajetReportLeadHistoryTableAction = (payload) => ({
  type: GET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
  payload,
});

export const setTrajetReportLeadHistoryTableAction = (payload, callback) => ({
  type: SET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
  payload,
  callback,
});

export const getTrajetReportLOVAction = (payload) => ({
  type: GET_TRAJET_REPORT_LOV_DATA,
  payload,
});

export const setTrajetReportLOVAction = (payload, callback) => ({
  type: SET_TRAJET_REPORT_LOV_DATA,
  payload,
  callback,
});

export const setTrajetReportTeamLeadAssignedAction = (payload) => ({
  type: SET_TRAJET_REPORT_TEAM_LEAD_ASSIGNED_DATA,
  payload,
});
